export default "__VITE_ASSET__DhF16pSn__"